import { saveAs } from "file-saver";
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Stack, Typography, Link, Button, Grid } from "@mui/material";
import { Download } from "@mui/icons-material";

import { AppContext } from "../../context/AppProvider";

export const Summary = (props) => {
  const { activation, fetchLicenseActivationKey } = useContext(AppContext);

  const location = useLocation();

  useEffect(() => {
    const searchParameters = new URLSearchParams(location.search);
    const customerId = searchParameters.get("customer");
    const paymentIntentId = searchParameters.get("payment_intent");

    if (paymentIntentId) {
      fetchLicenseActivationKey(customerId, paymentIntentId);
    }
  }, []);

  const download = () => {
    const blob = new Blob([activation.activationKey], {
      type: "text/plain;charset=utf-8",
    });
    saveAs(blob, `kasm-activation-key.txt`);
  };

  const showActivationInstructions = (e) => {
    e.preventDefault();
    window.open(process.env.REACT_APP_ACTIVATION_URL, "_blank");
  }

  return (
    <Grid container>
      <Grid item md={6} className="form">
        <Stack direction="column" spacing={3} mb={2}>
          <Typography variant="h4">Thank you!</Typography>
          <Typography variant="body">
            Your purchase of Kasm Workspaces was successfully processed.
          </Typography>
          <div>
            <Button
              size="large"
              variant="contained"
              endIcon={<Download />}
              onClick={download}
            >
              Download Activation Key
            </Button>
          </div>
          <Typography variant="body2">
            You can find detailed activation instructions <Link onClick={showActivationInstructions}>here</Link>.
          </Typography>

        </Stack>
      </Grid>

      <Grid item md={6} className="summary">
        <div className="summary-holder">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={5}
          >
            {activation.activationKey && (

              <Stack direction="column" sx={{ width: "100%" }} spacing={2}>
                <div className="summary-box">
                <pre contentEditable={true} style={{ fontSize: '14px', lineHeight: '1.5', border: 'none', background: 'transparent' }}>{activation.activationKey}</pre>
                </div>
                <Stack direction="row" alignItems="center" justifyContent="center">
                  <Button
                    sx={{ marginTop: '20px' }}
                    size="large"
                    variant="contained"
                    endIcon={<Download />}
                    onClick={download}
                  >
                    Download Activation Key
                  </Button>
                </Stack>
              </Stack>

            )}
          </Stack>
        </div>
      </Grid>
    </Grid>
  );
};
